import { cn } from '@/lib/utils'

interface AppointmentsSheetSectionCardProps {
  title: React.ReactNode
  body: React.ReactNode
  className?: string
}

/** Titled section card for the Appointments details sheet (matches Call Logs). */
export function AppointmentsSheetSectionCard({
  title,
  body,
  className,
}: AppointmentsSheetSectionCardProps) {
  return (
    <div
      className={cn(
        'bg-app border border-neutral-ui-border shadow-[var(--shadow-md)] rounded-lg p-3',
        className
      )}>
      <p className="text-muted-foreground mb-2 text-xs font-medium tracking-wide">
        {title}
      </p>
      {body}
    </div>
  )
}
